module.exports = __webpack_public_path__ + "static/media/OrganigramaIUDLM.2aac53b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/OrganigramaIUDLM.jpg
// module id = 828
// module chunks = 0